import { useAvailabilities } from '../Providers/Availabilities'
import { useCustomFilters } from '../Providers/CustomFilters'
import { usePermissionsData } from '../Providers/PermissionsProvider'
import { SourcesVisibility } from '../lib/sources'

export const useSourcesVisibility = (): SourcesVisibility => {
  const { formattedState } = useCustomFilters()
  const {
    permissions: { canSeeExpenses },
  } = usePermissionsData()
  const { availabilities } = useAvailabilities()
  const employeeCosts = formattedState.employeeCosts

  if (!employeeCosts) {
    return {
      canSeeAgreements: false,
      canSeeEmployeeExpenses: false,
      canSeeLaborCosts: false,
      canSeeCompensations: false,
    }
  }

  const { agreement_data, employee_expenses, labor_costs } = employeeCosts

  const sources = {
    agreements: agreement_data?.length ?? 0,
    expenses: employee_expenses?.length ?? 0,
    payroll: labor_costs?.length ?? 0,
  }

  const anySourceSelected = sources.agreements > 0 || sources.expenses > 0 || sources.payroll > 0
  const canSeeLaborCosts = availabilities.canSeeLaborCosts

  return {
    canSeeAgreements: anySourceSelected ? sources.agreements > 0 : true,
    canSeeEmployeeExpenses: canSeeExpenses && (anySourceSelected ? sources.expenses > 0 : true),
    canSeeLaborCosts: canSeeLaborCosts && (anySourceSelected ? sources.payroll > 0 : true),
    canSeeCompensations: availabilities.canSeeCompensations,
  }
}
